import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";

function App() {
  return (
      <div className="App">
      {/* <Route exact path='/' component={Home} /> */}
       <Home/>
      </div>
  );
}

export default App;
